/* One-time, reduced-motion-aware entrances for requested About cards and product Reviews title. */
(() => {
  const init = () => {
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = document.querySelectorAll('body.page-about #MainContent .text-with-icons__block,body.page-about #MainContent .promo-grid .flex-grid__item,body.template-product fws-product-reviews .fws-reviews-title');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        requestAnimationFrame(() => requestAnimationFrame(() => { entry.target.dataset.fwsDetailReveal = 'visible'; }));
        observer.unobserve(entry.target);
      });
    }, {threshold: .12});
    targets.forEach(element => {
      if (element.dataset.fwsDetailReveal) return;
      element.dataset.fwsDetailReveal = 'pending';
      element.addEventListener('focusin', () => { element.dataset.fwsDetailReveal = 'visible'; observer.unobserve(element); }, {once:true});
      observer.observe(element);
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, {once:true}) : init();
  document.addEventListener('shopify:section:load', init);
})();

/* Pickup tooltip accessibility only; native Escape, close and backdrop handlers remain unchanged. */
(() => {
  const init = () => {
    if (!document.body.classList.contains('template-product')) return;
    const selector = 'tool-tip-trigger[data-tool-tip="store-availability"]';
    const prepare = root => root.querySelectorAll(selector).forEach(trigger => {
      trigger.setAttribute('role','button');
      trigger.setAttribute('tabindex','0');
      trigger.setAttribute('aria-haspopup','dialog');
    });
    prepare(document);
    document.querySelectorAll('[data-store-availability-holder]').forEach(holder => {
      new MutationObserver(() => prepare(holder)).observe(holder,{childList:true,subtree:true});
    });
    let opener = null;
    let active = null;
    document.addEventListener('tooltip:open', event => {
      if (event.detail?.context === 'store-availability') {
        opener = event.target.closest?.(selector) || document.activeElement;
      }
    },true);
    document.querySelectorAll('tool-tip').forEach(popup => {
      let wasOpen = false;
      let original = null;
      const sync = () => {
        const open = popup.dataset.toolTip === 'store-availability' && popup.dataset.toolTipOpen === 'true';
        if (open && !wasOpen) {
          wasOpen = true; active = popup;
          const close = popup.querySelector('[data-tool-tip-close]');
          original = {role:popup.getAttribute('role'),modal:popup.getAttribute('aria-modal'),label:popup.getAttribute('aria-label'),closeLabel:close?.getAttribute('aria-label')};
          popup.setAttribute('role','dialog');
          popup.setAttribute('aria-modal','true');
          popup.setAttribute('aria-label','Pickup information');
          close?.setAttribute('aria-label','Close pickup information');
          requestAnimationFrame(() => {
            if (popup.dataset.toolTipOpen === 'true' && popup.dataset.toolTip === 'store-availability') (close || popup).focus({preventScroll:true});
          });
        } else if (!open && wasOpen) {
          wasOpen = false; active = null;
          const restore = (element,name,value) => { if (!element) return; value === null ? element.removeAttribute(name) : element.setAttribute(name,value); };
          restore(popup,'role',original.role); restore(popup,'aria-modal',original.modal); restore(popup,'aria-label',original.label);
          restore(popup.querySelector('[data-tool-tip-close]'),'aria-label',original.closeLabel);
          if (opener?.isConnected) opener.focus({preventScroll:true});
          opener = null;
        }
      };
      new MutationObserver(sync).observe(popup,{attributes:true,attributeFilter:['data-tool-tip','data-tool-tip-open']});
      sync();
    });
    document.addEventListener('keydown', event => {
      if (active && event.key === 'Tab') {
        const items = [...active.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        event.preventDefault(); event.stopPropagation();
        if (!items.length) { active.focus({preventScroll:true}); return; }
        const index = items.indexOf(document.activeElement);
        const next = index < 0 ? (event.shiftKey ? items.length-1 : 0) : (index + (event.shiftKey ? -1 : 1) + items.length) % items.length;
        items[next].focus({preventScroll:true});
      } else if (!active && (event.key === 'Enter' || event.key === ' ') && event.target.matches?.(selector)) {
        event.preventDefault();
        event.target.click();
      }
    },true);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded',init,{once:true}) : init();
})();

/* Quick Contact: a nonempty placeholder keeps Safari's floating phone label consistent. */
(() => {
  const mobile = window.matchMedia('(max-width:749px)');
  const originals = new WeakMap();
  const syncPhonePlaceholder = () => {
    document.querySelectorAll('#globo-formbuilder-120018 input[data-type="phone"]').forEach(input => {
      if (!originals.has(input)) originals.set(input, input.getAttribute('placeholder') || '');
      const placeholder = mobile.matches ? 'Phone' : originals.get(input);
      if (input.getAttribute('placeholder') !== placeholder) input.setAttribute('placeholder', placeholder);
    });
  };
  syncPhonePlaceholder();
  mobile.addEventListener('change', syncPhonePlaceholder);
  new MutationObserver(syncPhonePlaceholder).observe(document.documentElement, {
    childList:true, subtree:true, attributes:true, attributeFilter:['placeholder']
  });
})();
